/*********************
 * Mobillor Technologies Pvt. ltd. CONFIDENTIAL
 * __________________
 *
 *  Mobillor Technologies Pvt. Ltd.
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Mobillor Technologies Pvt. Ltd.
 * The intellectual and technical concepts contained
 * herein are proprietary to Mobillor Technologies Pvt. Ltd.
 * may be covered by Rebublic Of India and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Mobillor Technologies Pvt. Ltd.
 */

import { useEffect, useState } from "react";
import { connect } from "react-redux";

// Dashboard components

// Dashboard example components

// @mui material components

import { getSubModulesByRoleId } from "../../store";

import Cookies from "universal-cookie";
import BOMW from "./BOMW";
import BOMW1 from "./BOMW1";

const cookies = new Cookies();

const Bom = ({ getSubModulesByRoleId, getSubModulesByRoleIdReducer }) => {
  let loginDetails = cookies.get("loginDetailsForWMS");
  let jwtToken = loginDetails?.jwt;
  let roleId = loginDetails.data.roleId;

  useEffect(() => {
    getSubModulesByRoleId(roleId, jwtToken);
  }, [roleId]);

  const [modulesData, setModulesData] = useState([]);

  useEffect(() => {
    setModulesData(
      getSubModulesByRoleIdReducer.subModulesByRoleData.data
        ? getSubModulesByRoleIdReducer.subModulesByRoleData.data
        : [],
    );
  }, [getSubModulesByRoleIdReducer]);

  let showBOMW1 = modulesData.find((moduleId) => moduleId.moduleId == "");

  let showBOMW = modulesData.find(
    (moduleId) => moduleId.moduleId == "bfb048ba-31e3-4f37-864d-f1f13091de17",
  );

  return (
    <>
      {showBOMW1 ? (
        <BOMW1 />
      ) : showBOMW ? (
        <BOMW />
      ) : (
        <>
          <h4 style={{ textAlign: "center", marginTop: "6rem" }}>
            No BOM Access
          </h4>
        </>
      )}
    </>
  );
};

const mapStateToProps = (state) => {
  return {
    getSubModulesByRoleIdReducer: state.getSubModulesByRoleIdReducer,
  };
};

const mapStateToDispatch = (dispatch) => {
  return {
    getSubModulesByRoleId: (roleId, jwtToken) =>
      dispatch(getSubModulesByRoleId(roleId, jwtToken)),
  };
};

export default connect(mapStateToProps, mapStateToDispatch)(Bom);
